<template>
  <div>
    <b-message
      title="Info"
      type="is-info"
      aria-close-label="Close message"
    >
      На данный момент можно посмотреть параметры в пределах текущего месяца, ниже можно выбрать период, по умолчанию
      это начало и конец текущего месяца
    </b-message>

    <b-field label="Select start period date of current month">
      <b-datepicker
        rounded
        size="is-medium"
        placeholder="Click to select..."
        v-model="startPeriodDate"
        :min-date=getFirstDayOfCurrentMonth()
        :max-date=getLastDayOfCurrentMonth()
      >
      </b-datepicker>
    </b-field>

    <b-field label="Select end period date of current month">
      <b-datepicker
        rounded
        size="is-medium"
        placeholder="Click to select..."
        v-model="endPeriodDate"
        :min-date=getFirstDayOfCurrentMonth()
        :max-date=getLastDayOfCurrentMonth()
      >
      </b-datepicker>
    </b-field>

    <p class="control">
      <button
        class="button is-primary"
        v-on:click="loadAggregateDataForPeriod()"
        :disabled="!!loading"
      >
        <span class="icon">
          <i class="fa fa-refresh"></i>
        </span>
        <span>Загрузить данные</span>
      </button>
    </p>

    <div
      class="summary-container"
      v-if="summaryData"
    >
      <div class="client-summary">
        <h2 class="client-summary-title"> {{ summaryData.clientName }}</h2>
        <div
          class="table-responsive"
          v-if="summaryData.clientSummary"
        >
          <h2>Затрачено за период по всем кампаниям</h2>
          <table class="table is-bordered">
            <thead>
            <tr>
              <th>Ресурс</th>
              <th>Значение</th>
            </tr>
            </thead>
            <tbody>
            <tr
              v-for="(value, name) in summaryData.clientSummary"
              :key="name"
            >
              <td class="td-resource">{{ name }}</td>
              <td class="td-value">{{ value }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="campaigns-summary-container">
        <div
          class="campaigns-summary-item"
          v-for="(item) in summaryData.campaignSummaryList"
          :key="item.campaignName"
        >
          <div class="campaigns-summary-item-title"> {{ item.campaignName }}</div>
          <div class="campaigns-summary-item-data">
            <div
              class="table-responsive"
              v-if="item.campaignSummary"
            >
              <h2>Затрачено за период по кампании</h2>
              <table class="table is-bordered">
                <thead>
                <tr>
                  <th>Ресурс</th>
                  <th>Значение</th>
                </tr>
                </thead>
                <tbody>
                <tr
                  v-for="(value, name) in item.campaignSummary"
                  :key="name"
                >
                  <td class="td-resource">{{ name }}</td>
                  <td class="td-value">{{ value }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>


<script>
import {mapGetters} from 'vuex'
import VisCommon from '../components/VisCommon'

const BILLING_API = 'billing/'
const _MS_PER_DAY = 1000 * 60 * 60 * 24

export default {
  name: 'BillingSummaryDashboard',
  extends: VisCommon,
  data() {
    return {
      loading: false,
      startPeriodDate: [],
      endPeriodDate: [],
      summaryData: {}
    }
  },
  created: function () {
    this.startPeriodDate = this.getFirstDayOfCurrentMonth()
    this.endPeriodDate = this.getLastDayOfCurrentMonth()
    this.loadAggregateDataForPeriod()
  },

  computed: {
    ...mapGetters([
      'authenticationToken',
      'clientId'
    ])
  },
  methods: {
    prepareSecurityHeader() {
      return {
        Authorization: `Bearer ${this.authenticationToken}`
      }
    },

    getFirstDayOfCurrentMonth: function () {
      var date = new Date()
      var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
      return firstDay
    },

    getLastDayOfCurrentMonth: function () {
      var date = new Date()
      var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
      return lastDay
    },

    dateDiffInDays(a, b) {
      // Discard the time and time-zone information.
      const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate())
      const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate())

      return Math.floor((utc2 - utc1) / _MS_PER_DAY)
    },

    // dd.mm.yyyy
    formatDateToStr(date) {
      var d = date.getDate()
      var m = date.getMonth() + 1
      var y = date.getFullYear()

      var dateString = (d <= 9 ? '0' + d : d) + '.' + (m <= 9 ? '0' + m : m) + '.' + y

      return dateString
    },

    loadAggregateDataForPeriod() {
      let that = this
      let difference = that.dateDiffInDays(this.startPeriodDate, this.endPeriodDate)
      if (difference < 1) {
        that.openNotificationWithType('danger', 'Ошибка: конечная дата должна быть больше, чем стартовая и разница между ними должна быть равна хотя бы одному дню')
      }
      that.loading = true
      this.$http.get(BILLING_API + 'getAggregateForPeriod/' + '?startPeriodDate=' + that.formatDateToStr(that.startPeriodDate) + '&endPeriodDate=' + that.formatDateToStr(that.endPeriodDate), {headers: this.prepareSecurityHeader()})
        .then((response) => {
          that.loading = false
          that.summaryData = response.data.response
        })
        .catch((error) => {
          that.loading = false
          console.log(error)
          that.openNotificationWithType('danger', 'Ошибка загрузки данных клиента. ')
        })
    }
  }
}
</script>

<style lang="css" scoped>
.control {
  margin-top: 1.5rem;
  text-align: center;
}

.button.is-primary {
  width: 100%;
  height: 50px;
}

.summary-container {
  max-width: 100%;
  padding: 0 2rem;
  margin: auto;
  margin-top: 3rem;
  display: flex;
  flex-wrap: wrap;
  justify-items: center;
  text-align: center;
}

.client-summary {
  display: flex;
  flex: 0 0 100%;
  width: 100%;
  padding: 0 1rem;
  flex-direction: column;
  text-align: center;
  box-shadow: 0px 2px 10px -4px rgba(0, 0, 0, 0.3);
  border-radius: 15px;
  min-height: 4rem;
}

.client-summary-title {
  margin-top: 2rem;
  margin-bottom: 2rem;
  font-weight: 600;
  font-size: 2rem;
}

.campaigns-summary-container {
  margin-top: 2rem;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.campaigns-summary-item {
  display: flex;
  width: 49%;
  margin-right: 1%;
  margin-bottom: 1rem;
  flex-direction: column;
  text-align: center;
  align-content: center;
  justify-content: center;
  justify-items: center;
  align-items: center;
  box-shadow: 0px 2px 10px -4px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}

.campaigns-summary-item-title {
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  font-size: 1rem;
}

.campaigns-summary-item-data {
  width: 100%;
  padding: 0 1rem;
}
</style>






// WEBPACK FOOTER //
// BillingSummaryDashboard.vue?0f635342